/**
 * Reviews — front end. Builds the dash indicators: one per card position the
 * row can scroll to, highlighting the current one; clicking jumps there.
 * Hidden when every card fits.
 */
( function () {
	const EDGE = 4;

	document.querySelectorAll( '.dlb-reviews' ).forEach( function ( section ) {
		const track = section.querySelector( '.dlb-reviews__track' );
		const dots = section.querySelector( '.dlb-reviews__dots' );
		if ( ! track || ! dots ) {
			return;
		}
		const list = track.querySelector( '.dlb-reviews__list' );

		function step() {
			const card = list.querySelector( '.dlb-review' );
			const gap =
				parseFloat( window.getComputedStyle( list ).columnGap ) || 0;
			return card ? card.offsetWidth + gap : track.clientWidth;
		}

		function positions() {
			const max = track.scrollWidth - track.clientWidth;
			return max <= EDGE ? 0 : Math.round( max / step() ) + 1;
		}

		function build() {
			const count = positions();
			dots.hidden = count < 2;
			if ( dots.children.length !== count ) {
				dots.replaceChildren();
				for ( let i = 0; i < count; i++ ) {
					const dot = document.createElement( 'button' );
					dot.type = 'button';
					dot.className = 'dlb-reviews__dot';
					dot.setAttribute(
						'aria-label',
						// eslint-disable-next-line @wordpress/i18n-no-variables -- plain JS view script.
						'Go to review ' + ( i + 1 ) + ' of ' + count
					);
					dot.dataset.index = String( i );
					dots.appendChild( dot );
				}
			}
			update();
		}

		function update() {
			const max = track.scrollWidth - track.clientWidth;
			const count = dots.children.length;
			// At the far end, light the last dot even if the step doesn't divide evenly.
			const current =
				track.scrollLeft >= max - EDGE
					? count - 1
					: Math.round( track.scrollLeft / step() );
			Array.from( dots.children ).forEach( function ( dot, i ) {
				dot.setAttribute(
					'aria-current',
					i === current ? 'true' : 'false'
				);
			} );
		}

		dots.addEventListener( 'click', function ( e ) {
			const dot = e.target.closest( '.dlb-reviews__dot' );
			if ( dot ) {
				track.scrollTo( {
					left: Number( dot.dataset.index ) * step(),
					behavior: 'smooth',
				} );
			}
		} );

		track.addEventListener( 'scroll', update, { passive: true } );
		window.addEventListener( 'resize', build );
		build();
	} );
} )();
